define('views/lib/Podio.Views.SideTabsLinkedAccountsLayout',['require','translate','underscore','jquery','backbone','collections/Podio.Collections.LinkedAccounts','collections/Podio.Collections.AccountProviders','views/lib/Podio.Views.ProvidersMatrix','views/lib/Podio.Views.SideTabsLayout','views/lib/Podio.Views.AccountsSettingsDropdown','lib/Podio.Config','lib/Podio.SingleSignOn','lib/Podio.UI.FlashMessage'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var collectionLinkedAccounts = require('collections/Podio.Collections.LinkedAccounts');
  var collectionAccountProviders = require('collections/Podio.Collections.AccountProviders');
  var viewProvidersGrid = require('views/lib/Podio.Views.ProvidersMatrix');
  var viewSideTabsLayout = require('views/lib/Podio.Views.SideTabsLayout');
  var viewAccountSettings = require('views/lib/Podio.Views.AccountsSettingsDropdown');
  var podioConfig = require('lib/Podio.Config');
  var singleSignOn = require('lib/Podio.SingleSignOn');
  var flashMessage = require('lib/Podio.UI.FlashMessage');

  return viewSideTabsLayout.extend({
    podioEvents: {
      'click .navigation li'  : 'onNavProviderClicked',
      'click .footer .cancel' : 'onFooterCancelButtonClicked',
      'click .footer .done'   : 'onFooterDoneButtonClicked'
    },

    bindEvents: function() {
      this.bind('connectService', this.installService, this);
      this.bind('accountsSettingsDropdown:accountChanged', this.onAccountChanged, this);
    },

    initLayout: function(capability) {
      _.bindAll(this, 'onOAuthComplete');
      this.bindEvents();

      // Data
      this.capability = capability;
      this.linkedAccounts = new collectionLinkedAccounts();
      this.linkedAccounts.bind('reset', this.onLinkedAccountsReset, this);
      this.accountProviders = new collectionAccountProviders();
      this.linkedAccountsState = new Backbone.Model();

      // Fetch
      this.dfdLinkedAccountsFetched = this.linkedAccounts.getConnectedByCapability(capability);
      this.dfdAccountProvidersFetched = this.accountProviders.getAvailableFor(this.capability);

      // Layout
      this.initTabsLayout.call(this);

      // Return promise
      return $.when(this.dfdLinkedAccountsFetched, this.dfdAccountProvidersFetched);
    },

    onLinkedAccountsReset: function() {
      this.installedProviders = this.linkedAccounts.getUniqueProviders();
      this.renderCurrentProvidersNav();
    },

    renderCurrentProvidersNav: function() {
      var self = this;

      // copy by value
      var currentOptions = this.navigationOptions.slice(0);

      // add items for existing linked accounts
      _.each(this.installedProviders, function(p) {
        if (p.get('provider') === 'legacy_google') {
          return;
        }

        currentOptions.push({
          id: p.get('provider'),
          label: p.get('capability_names')[self.capability],
          className: 'provider',
          icon: 'icon-16-integration-' + p.get('provider')
        });
      });

      // add an additional menu item to add account, if the user is not sharefile_limited
      if (!podioConfig.user.from_sharefile) {
        currentOptions.push({
          id: 'add-account',
          label: t('Add linked account #linkedAccounts'),
          className: 'add-new',
          icon: 'icon-16-green-plus'
        });
      }

      this.renderNavigation(currentOptions, (this.selectedTabId ? this.selectedTabId : this.navigationSelectedItem) );
    },

    onNavProviderClicked: function(elmTarget, e) {
      e.stopPropagation();

      // Call base method in sideTabsLayout
      this.onNavItemClicked.apply(this, _.toArray(arguments) );

      if (this.selectedTabId === 'add-account') {

        this.displayProvidersGrid();
        this.destroyProviderSettings();

      } else {
        this.renderProvider(this.selectedTabId);
      }

    },

    renderProvider: function(selectedTabId) {
      this.destroyProvidersGrid();

      var provider = this.accountProviders && this.accountProviders.getByName(selectedTabId);

      if (provider) {

        // Get first linked account for a given provider, if non selected.
        if (!this.linkedAccountsState.get( provider.get('name') )) {
          var linkedAccountId = this.linkedAccounts.getByProvider( provider.get('name') )[0].id;
          this.setCurrentLinkedAccountId( provider.get('name') , linkedAccountId);
        }

        this.renderProviderSettings(provider);

      } else {
        this.destroyProviderSettings();
      }

      this.trigger('sideTabsLinkedAccountsLayout:providerChanged', selectedTabId, provider);
    },

    destroyProviderSettings: function() {
      // Hide options button
      this.elm.find('.footer .options').addClass('hidden');

      if (this.providerSettingsView) {
        this.providerSettingsView.dispose();
      }

      $('.side-tabs-linked-accounts-option').remove();
    },

    renderProviderSettings : function(provider) {

      // Show options button
      this.elm.find('.footer .options').removeClass('hidden');

      if (this.providerSettingsView) {
        this.providerSettingsView.dispose();
      }

      // Clean
      $('.side-tabs-linked-accounts-option').remove();

      // Create wrapper element
      var elmSettingsOptionsWrapper = $('<div />', { 'class': 'balloon fixed below settings-balloon within-modal side-tabs-linked-accounts-options'});
      elmSettingsOptionsWrapper.appendTo(this.elmMain);

      // Render
      this.providerSettingsView = new viewAccountSettings({
        el                      : elmSettingsOptionsWrapper,
        eventBus                : this.eventBus,
        account                 : provider,
        currentLinkedAccountId  : this.linkedAccountsState.get(provider.get('name')),
        accounts                : this.linkedAccounts.getByProvider(provider.get('name'))
      });

      this.providerSettingsView.render();
    },

    destroyProvidersGrid: function() {
      if (this.providersGrid) {
        this.elmContent.empty();
        this.providersGrid.dispose();
        delete this.providersGrid;
      }
    },

    displayProvidersGrid: function() {
      this.elmContent.empty();

      // Render
      this.providersGrid = new viewProvidersGrid({
        el : this.elmContent,
        model: this.accountProviders,
        eventBridge: this.options.eventBus,
        description: this.providerGridDescription,
        capability: 'contacts'
      });

      this.providersGrid.render();
      this.providersGrid.renderProviders();
    },

    setCurrentLinkedAccountId: function(providerName, linkedAccountId) {
      var data = {};
      data[providerName] = linkedAccountId;
      this.linkedAccountsState.set(data);
    },

    getCurrentLinkedAccountId: function(providerName) {
      return this.linkedAccountsState.get(providerName);
    },

    installService: function(providerName) {
      singleSignOn.signals.onOAuthComplete.add(this.onOAuthComplete);
      singleSignOn.connect(providerName);
    },

    switchAccount: function(providerName, linkedAccountId) {
      // Update state
      this.setCurrentLinkedAccountId(providerName, linkedAccountId);

      // Re-render provider settings
      var provider = this.accountProviders.getByName(providerName);
      this.renderProviderSettings(provider);
    },

    onOAuthComplete: function(data) {
      var self = this;

      flashMessage.show(t('The account {0} has been successfully connected #linkedAccounts').format(data.label));

      // Refresh linked accounts
      this.linkedAccounts.getConnectedByCapability(this.capability).done(function() {
        var provider = self.accountProviders.getByName(self.selectedTabId);
        self.renderProviderSettings(provider);
      });

      // Switch account
      this.switchAccount(data.provider, data.linked_account_id);
      this.selectedTabId = data.provider;
      this.navigationSelectedItem = data.provider;

      // Trigger
      this.trigger('sideTabsLayout:accountConnected', data.provider, data.linked_account_id);
    },

    onAccountChanged: function(providerName, linkedAccountId) {
      this.switchAccount(providerName, linkedAccountId);
      this.trigger('sideTabsLinkedAccountsLayout:accountChanged', providerName, linkedAccountId);
    },

    disposeTabsLayout: function() {
      this.destroyProvidersGrid();
      this.destroyProviderSettings();
      if (this.providerSettingsView) {
        this.providerSettingsView.dispose();
      }
      this.destroy();
      this.unbind('connectService', this.installService);
      this.unbind('accountsSettingsDropdown:accountChanged', this.onAccountChanged);
      if (this.linkedAccounts) {
        this.linkedAccounts.unbind('reset', this.onLinkedAccountsReset);
      }
    }

  });

});

